// It is safe to use this package here, because it is available in the new
// consumer app.
import { notFound } from 'next/navigation';

export default notFound;
